import { computed } from "vue";

export function usePaginate() {
    // Get store data
    const { result, selectedState, searchText, loading } = storeToRefs(useSearchStore());

    const route = useRoute();

    const doAlgoliaSearch = computed(() => {
        return !!searchText.value;
    });

    const metaCurrentPage = computed(() => {
        if (!loading && doAlgoliaSearch.value) {
            return result ? result.value?.page + 1 : 1;
        }
        return result.value?.meta?.current_page ?? 1;
    });
    const metaTotalPage = computed(() => {
        if (doAlgoliaSearch.value) {
            result ? result.value?.nbPages : 1;
        }
        return result.value?.meta ? Math.ceil(result.value.meta.total / result.value.meta.per_page) : 1;
    });
    const paginationSummary = computed(() => {
        if (doAlgoliaSearch.value && result.value?.hits) {
            if (result.value.hits.length <= 0) {
                return "";
            }
            if (metaTotalPage.value <= 1) {
                return "Showing 1 to " + result.value.hits.length;
            }
            const start = result.value.page * result.value.hitsPerPage + 1;
            const end = start + result.value.hits.length - 1;
            const totalHits = result.value.nbHits;
            return `Showing ${start} to ${end}  of ${totalHits} — Page ${metaCurrentPage.value} of ${metaTotalPage.value}`;
        }
        if (result.value?.meta) {
            const meta = result.value.meta;
            if (meta.total <= 0) {
                return "";
            }
            if (metaTotalPage.value <= 1) {
                return `Showing 1 to ${meta.total}`;
            }
            return `Showing ${meta.from} to ${meta.to}  of ${meta.total} — Page ${metaCurrentPage.value} of ${metaTotalPage.value}`;
        }
        return "";
    });
    const linkPrev = computed(() => {
        if (doAlgoliaSearch.value) {
            if (!result || !result.value?.page) {
                return "";
            }

            let pageURL = `/products/page/`;
            if (selectedState.value) {
                pageURL = `/products/state/${selectedState.value.toLowerCase()}/page/`;
            }

            const queryAry = [];
            for (const [key, value] of Object.entries(route.query)) {
                queryAry.push(`${key}=${value}`);
            }

            return pageURL + result.value.page + "?" + queryAry.join("&");
        }

        if (result && result.value?.links?.prev) {
            let pageURL = `/products/page/`;
            if (selectedState.value) {
                pageURL = `/products/state/${selectedState.value.toLowerCase()}/page/`;
            }

            const queryAry = [];
            for (const [key, value] of Object.entries(route.query)) {
                queryAry.push(`${key}=${value}`);
            }

            const urlParams = new URLSearchParams(result.value.links.prev);
            return pageURL + urlParams.get("page") + "?" + queryAry.join("&");
        }
        return "";
    });
    const linkNext = computed(() => {
        if (doAlgoliaSearch.value) {
            const nextPage = result ? result.value?.page + 2 : 1;

            if (!result || nextPage > result.value?.nbPages) {
                return "";
            }

            let pageURL = `/products/page/`;
            if (selectedState.value) {
                pageURL = `/products/state/${selectedState.value.toLowerCase()}/page/`;
            }

            const queryAry = [];
            for (const [key, value] of Object.entries(route.query)) {
                queryAry.push(`${key}=${value}`);
            }

            return pageURL + nextPage + "?" + queryAry.join("&");
        }

        if (result && result.value?.links?.next) {
            let pageURL = `/products/page/`;
            if (selectedState.value) {
                pageURL = `/products/state/${selectedState.value.toLowerCase()}/page/`;
            }

            const queryAry = [];
            for (const [key, value] of Object.entries(route.query)) {
                queryAry.push(`${key}=${value}`);
            }

            const urlParams = new URLSearchParams(result.value.links.next);
            return pageURL + urlParams.get("page") + "?" + queryAry.join("&");
        }
        return "";
    });

    return {
        doAlgoliaSearch,
        result,
        selectedState,
        metaCurrentPage,
        metaTotalPage,
        paginationSummary,
        linkPrev,
        linkNext,
    };
}
